import { Component } from "@angular/core";
import { IonicPage, NavController, NavParams } from "ionic-angular";
import { AccountProvider } from "../../providers/account/account";

/**
 * Generated class for the ForgotPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: "page-forgot",
  templateUrl: "forgot.html",
  providers: [AccountProvider]
})
export class ForgotPage {
  isSuccessed = false;
  public model = {};

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private accountProvider: AccountProvider
  ) {}

  ionViewDidLoad() {
    console.log("ionViewDidLoad ForgotPage");
  }

  forgot() {
    this.isSuccessed = true;
    this.accountProvider.forgot(this.model).subscribe(resp => {
      console.log(resp);
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/forgot/forgot.ts